import React, { Component } from 'react';
import { Formik } from 'formik';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

import { FormStyled } from '../../styles/form';
import SelectStyled from '../../styles/select';

class PieceInventoryFilterForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPiece: null,
    };
  }

  handleValidate = () => {
    const errors = {};

    return errors;
  };

  handleSubmit = () => async (values, { setSubmitting }) => {
    const { onList } = this.props;
    const { selectedPiece } = this.state;

    const data = {
      ...values,
      piece: selectedPiece ? selectedPiece.value : null,
    };

    if (values || selectedPiece) {
      await onList({ ...data });
    }

    setSubmitting(false);
  };

  optionTotal = option => {
    const totalStr = option.label.split('||')[1].trim();

    return parseInt(totalStr, 10) || 0;
  };

  render() {
    const { pieces } = this.props;

    const { selectedPiece } = this.state;

    // const [selectedPiece, setSelectedPiece] = React.useState(
    //     pieces
    //       ? {
    //           value: piece.uuid,
    //           label: `${piece.description} || ${piece.total || 0}`,
    //         }
    //       : null
    //   );

    const pieceOptions = pieces
    ? pieces.map(piece => ({
        value: piece.uuid,
        label: `${piece.description} || ${piece.total || 0}`,
        total: piece.total || 0,
      }))
    : [];

    return (
      <div>
        <Formik
          enableReinitialize
          initialValues={{
            piece: selectedPiece,
            document: '',
          }}
          validate={this.handleValidate}
          onSubmit={this.handleSubmit(this.props)}
        >
          {({
            dirty,
            handleReset,
            isSubmitting,
            values,
            handleChange,
            handleBlur,
            errors,
            touched,
          }) => (
            <FormStyled>
              <h1>Filtros</h1>

              <div className="formData">
                <strong>DOCUMENTO</strong>
                <input
                  id="document"
                  name="document"
                  type="text"
                  value={values.document}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={!!(errors.document && touched.document)}
                />
                {errors.document && touched.document && (
                  <span>{errors.document}</span>
                )}
              </div>

              {/* <ReactSelect
                placeholder="PEÇAS"
                isDisabled={!pieces}
                styles={SelectStyled}
                value={selectedPiece}
                onChange={e => {
                  this.setState({ selectedPiece: e });
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                options={pieceOptions}
              /> */}

<ReactSelect
                  value={selectedPiece}
                  onChange={e => {
                    this.setState({ selectedPiece: e });
                  }}
                  options={pieceOptions}
                  styles={{
                    ...SelectStyled,
                    option: (provided, state) => {
                      const isLow = this.optionTotal(state.data) <= 4;
                      return {
                        ...provided,
                        backgroundColor: isLow && '#ff0000',
                        fontWeight: isLow ? 'bold' : 'normal',
                        color: isLow ? '#fff' : '#000',
                      };
                    },
                    singleValue: (provided, state) => {
                      const isLow = this.optionTotal(state.data) <= 4;
                      return {
                        ...provided,
                        color: isLow ? '#ff0000' : '#000',
                        fontWeight: isLow ? 'bold' : 'normal',
                      };
                    },
                  }}
                  placeholder="PEÇAS"
                  isDisabled={!pieces}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                />

              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={isSubmitting}
                style={{ margin: '10px' }}
              >
                BUSCAR
              </Button>

              <Button
                variant="contained"
                color="primary"
                type="reset"
                onClick={() => {
                  handleReset();
                  this.setState({
                    selectedPiece: null,
                  });
                }}
                disabled={(!dirty && !selectedPiece) || isSubmitting}
                style={{ margin: '10px' }}
              >
                DESFAZER
              </Button>
            </FormStyled>
          )}
        </Formik>
      </div>
    );
  }
}

PieceInventoryFilterForm.propTypes = {
  onList: PropTypes.func.isRequired,
  pieces: PropTypes.arrayOf(PropTypes.shape(PropTypes.string)),
};

PieceInventoryFilterForm.defaultProps = {
  pieces: [],
};

export default PieceInventoryFilterForm;
